import { styled } from '@openeducation/oe-it-themes';
import { StyleProp, StyleSheet, TextStyle } from 'react-native';
import { useTheme } from 'react-native-paper';

import HoverableButton from '../../atoms/hoverable-button/hoverable-button';
import { OEText } from '../../atoms/oe-text/oe-text';
import type { TopMenuItem } from '../../molecules/top-menu/top-menu';
import { color, ml } from '../../style-utils';
import { Icon } from '../icon/icon';

export function TopMenuLink({
  name,
  onPress,
  containerStyle,
  textStyle,
  hoveredTextStyle,
  rightIcon,
}: TopMenuItem) {
  const { colors } = useTheme();

  const _textStyle: StyleProp<TextStyle> = [styles.textStyle, textStyle];

  const _hoveredTextStyle: StyleProp<TextStyle> = [
    styles.textStyle,
    color(colors.primary),
    hoveredTextStyle,
  ];

  return (
    <StyledLink onPress={onPress} containerStyle={containerStyle}>
      {(isHovered) => (
        <>
          <OEText style={isHovered ? _hoveredTextStyle : _textStyle}>
            {name}
          </OEText>
          {rightIcon && (
            <Icon
              style={[isHovered ? _hoveredTextStyle : _textStyle, ml(8)]}
              name={rightIcon}
              type="solid"
            />
          )}
        </>
      )}
    </StyledLink>
  );
}

const StyledLink = styled(HoverableButton)`
  margin: 0 8px;
  flex-direction: row;
  align-items: center;
`;

const styles = StyleSheet.create({
  textStyle: {
    fontSize: 16,
    fontWeight: '600',
  },
});
